import IsRegularGameRule from "./is-regular-game-rule";

export default class IsPatGameRule extends IsRegularGameRule {
    // eslint-disable-next-line no-unused-vars
    applicable(gameContext, ruleContext, eventConfiguration, { play }) {
        return !super.applicable(gameContext, ruleContext, eventConfiguration, {
            play
        });
    }
    // eslint-disable-next-line no-unused-vars
    async apply(gameContext, ruleContext, eventConfiguration) {}
}
